var exports = {
  "zC": "images__8Xd7Ct",
  "QY": "imageButton__ZhDTPM",
  "Sl": "image__LZR_KD",
};

module.exports = exports;
